module.exports = __webpack_public_path__ + "static/media/testimonial.cdd3f7c2.png";